import React from 'react'
import { useNavigate } from 'react-router-dom'
import VideoCard from './VideoCard'
import YoutubeEmbed from './YoutubeEmbed'

const HeroSection = () => {
    const navigate = useNavigate()

    return (
        <div className="flex flex-col items-center mt-6 lg:mt-10">
            <h1 className="text-4xl sm:text-6xl lg:text-7xl text-center tracking-wide">
                Sua nova forma de aprender inglês
                <span className="bg-gradient-to-r from-purple-500 to-purple-800 text-transparent bg-clip-text">
                    {' '}
                    está aqui!
                </span>
            </h1>
            <p className="mt-10 text-lg text-center text-neutral-500 max-w-4xl">
                Com o LinguaLearn você aumentará o seu vocabulário e treinará o speaking de uma forma mais eficiente e divertida além de saber exatamente onde precisa melhorar!
            </p>
            <div className="flex justify-center my-10">
                <a
                    onClick={() => {
                        navigate('/login')
                    }}
                    href="#"
                    className="text-white bg-gradient-to-r font-semibold from-purple-500 to-purple-800 py-3 px-4 mx-3 rounded-md"
                >
                    Comece de Graça!
                </a>
                {/* <a href="#" className="py-3 px-4 mx-3 rounded-md border">
                    Documentação
                </a> */}
            </div>
            <div className="flex mt-10 justify-center">
                <YoutubeEmbed videoId="mhxKeUMofzI"/>
            </div>
        </div>
    )
}

export default HeroSection
